import { Link, TrackingData } from '@ecm/router';

import { DeviceAction } from '../../api/dashboardV7/device/deviceAction';
import { SuspendedViewModel } from '../common/suspended.view-model';
import { ButtonViewModel } from './button.view-model';
import { SubItemViewModel } from './subItem.view-model';

export class ItemV7ViewModel {
    public contractId?: string;
    public imageUrl?: string;
    public defaultImage = true;
    public id: string;
    public section: string;
    public name: string;
    public category: string;
    public content?: string | string[];
    public contentFixe?: string;
    public link?: Link;
    public href?: string;
    public button?: ButtonViewModel;
    public subItems: SubItemViewModel[];
    public partialWarnTitle?: string;
    public suspendedInfo?: SuspendedViewModel;
    public picto?: string;
    public brand?: string;
    public isTv?: boolean;
    public trackingData?: TrackingData;
    public isMultiSim?: boolean;
    public actions?: Array<DeviceAction>;
    public actionsKo?: boolean;
}
